module.exports = __webpack_public_path__ + "img/FHD.f009dac7.svg";